
import api from '@/api/proxyWeb/habilitations'

export default {

    getAll({ commit }) {

        commit('setHabilitations', [])
        
        return api.list()
            .then(habilitations => {
                commit('setHabilitations', habilitations)
            })
    }    
}